import { Button, Space, Table, Tag, Input, DatePicker, Checkbox, Form, Select, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { getUsers, getUser, addMeals, updateMeals, getMealsByID, getMeals } from '../../service/auth/AuthService';
import { getToken } from '../../helper/tokenHelper';
import { useNavigate, useSearchParams } from 'react-router-dom';

import './OrderEdit.scss';

export default function OrderEdit() {
	const [formEdit] = Form.useForm();
	const [usersCompany, getUsersCompany] = useState<any[]>([]);
	const [usersMeal, setUsersMeal] = useState<any>();
	const [idUserInformation, getIDUserInformation] = useState<number>(0);
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const idMeal = searchParams.get('idMeal');

	useEffect(() => {
		getUser()
			.then((res: any) => {
				console.log(res);
				getIDUserInformation(res.data.data.id);
			})
			.catch((err: any) => {
				console.log(err);
			});
		getMealsByID(idMeal)
			.then((res: any) => {
				console.log(res);
				setUsersMeal(res.data.result);
			})
			.catch((err: any) => {
				console.log(err);
			});

		getUsers()
			.then((res: any) => {
				console.log(res);
				getUsersCompany(res.data.data);
			})
			.catch((err: any) => {
				console.log(err);
			});
	}, []);
	console.log(usersMeal);

	if (usersMeal) {
		formEdit.setFieldsValue({
			shoplink: usersMeal.shoplink,
			payer: usersMeal.payer,
		});
	}
	const { Option } = Select;
	const onFinish = (values: any) => {
		console.log('Success:', values);
		console.log('Success:', usersMeal.id);
		
		// return;
		const paramsEdit = {
			shoplink: values.shoplink,
			shopprice: usersMeal.shopprice,
			totalneed2pay: usersMeal.totalneed2pay,
			creator: usersMeal.creator,
			payer: values.payer,
			status: usersMeal.status,
			created: usersMeal.created,
			modified: new Date().toISOString(),
		};
		console.log(paramsEdit);
		updateMeals(paramsEdit, usersMeal.id)
			.then((res: any) => {
				console.log(res);
				message.success('Bạn đã sửa bữa ăn thành công');
				return;
				navigate('/home');
			})
			.catch((err: any) => {
				console.log(err);
				message.error(err.response.data.detail);
			});
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log('Failed:', errorInfo);
	};
	return (
		<div>
			<div className="text-center text-base ">
				<h1 className="my-5 text-lg">Bữa ăn</h1>
				<div className="w-full mx-auto border border-gray-500 p-5 rounded-md form-order">
					<Form
						name="basic"
						labelCol={{ span: 4 }}
						wrapperCol={{ span: 16 }}
						initialValues={{ remember: true }}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete="off"
						form={formEdit}
					>
						<Form.Item
							label="Tên cửa hàng"
							name="shoplink"
							rules={[{ required: true, message: 'Please input your shop!' }]}
							// className="input-shop"
						>
							<Input />
						</Form.Item>

						<Form.Item
							label="Người trả"
							name="payer"
							rules={[{ required: true, message: 'Please input your payer!' }]}
							className="text-left mx-auto"
						>
							<Select>
								{usersCompany.map((item: any, index) => {
									return (
										<>
											<Option value={item.id}>{item.fullname}</Option>
										</>
									);
								})}
							</Select>
						</Form.Item>
						<Form.Item wrapperCol={{ offset: 8, span: 32 }} className="button-submit">
							<Button
								type="primary"
								htmlType="submit"
								disabled={usersMeal ? usersMeal.creator != idUserInformation : true}
							>
								Sửa bữa ăn
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		</div>
	);
}
